// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customers-page {
  animation: fadeIn 0.5s ease-in-out;
}

.page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  text-align: center;
}

.page--empty img {
  width: 120px;
  height: 120px;
  margin-bottom: 24px;
}

.page--empty h3 {
  font-size: 20px;
  font-weight: 500;
  color: #6b7280;
}

/* --- Header & Controls --- */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.page-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #174078;
  margin: 0;
  text-align: left;
  flex-grow: 1;
  align-self: flex-start;
}

.page-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  background-color: #ffe3d1;
}

.filter-btn img {
  height: 20px;
  width: 20px;
}

.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 12px;
  width: 300px;
}

.page-search-bar img {
  height: 16px;
  opacity: 0.5;
}

.page-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}

.table-container {
  background-color: #fff;
  border-radius: 12px;
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
}

.data-table th {
  background-color: #f2f7ff;
  color: #1e3a8a;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
}

.data-table td {
  color: #374151;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.action-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.action-icon:hover {
  opacity: 1;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.status-verified {
  background-color: #def7ec; /* Green */
  color: #046c4e;
}

.status-blocked {
  background-color: #fee2e2; /* Red */
  color: #991b1b;
}

.status-unverified {
  background-color: #fffbeb; /* Yellow */
  color: #92400e;
}

/* --- Footer & Pagination --- */

/* Add to CustomersPage.css */

.filter-wrapper {
  position: relative;
  display: inline-block;
}

.filter-dropdown {
  position: absolute;
  top: 100%; /* Position below button */
  right: 0;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 10;
  overflow: hidden;
  margin-top: 5px;
}

.filter-dropdown div {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background 0.2s;
}

.filter-dropdown div:hover {
  background-color: #f5f7fa;
}

.filter-dropdown div.selected {
  background-color: #f0f4ff;
  color: #174078;
  font-weight: 600;
}
/* --- RESPONSIVE STYLES --- */
@media (max-width: 992px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  .page-controls {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
  }
}

@media (max-width: 480px) {
  .page-header h3,
  .page--empty h3 {
    font-size: 16px;
  }
  .data-table td {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CustomersPage/CustomersPage.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,QAAQ;EACnC,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,cAAc;AAChB;;AAEA,gCAAgC;;AAEhC,6BAA6B;;AAE7B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,0BAA0B;EACrC,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA,8BAA8B;AAC9B;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".customers-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  text-align: center;\n}\n\n.page--empty img {\n  width: 120px;\n  height: 120px;\n  margin-bottom: 24px;\n}\n\n.page--empty h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n/* --- Header & Controls --- */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.page-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n  text-align: left;\n  flex-grow: 1;\n  align-self: flex-start;\n}\n\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  cursor: pointer;\n  background-color: #ffe3d1;\n}\n\n.filter-btn img {\n  height: 20px;\n  width: 20px;\n}\n\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 300px;\n}\n\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n}\n\n.page-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n\n.table-container {\n  background-color: #fff;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.data-table th {\n  background-color: #f2f7ff;\n  color: #1e3a8a;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: none;\n}\n\n.data-table td {\n  color: #374151;\n}\n\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.action-icon {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.action-icon:hover {\n  opacity: 1;\n}\n\n.status-badge {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-verified {\n  background-color: #def7ec; /* Green */\n  color: #046c4e;\n}\n\n.status-blocked {\n  background-color: #fee2e2; /* Red */\n  color: #991b1b;\n}\n\n.status-unverified {\n  background-color: #fffbeb; /* Yellow */\n  color: #92400e;\n}\n\n/* --- Footer & Pagination --- */\n\n/* Add to CustomersPage.css */\n\n.filter-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.filter-dropdown {\n  position: absolute;\n  top: 100%; /* Position below button */\n  right: 0;\n  background-color: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 120px;\n  z-index: 10;\n  overflow: hidden;\n  margin-top: 5px;\n}\n\n.filter-dropdown div {\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  transition: background 0.2s;\n}\n\n.filter-dropdown div:hover {\n  background-color: #f5f7fa;\n}\n\n.filter-dropdown div.selected {\n  background-color: #f0f4ff;\n  color: #174078;\n  font-weight: 600;\n}\n/* --- RESPONSIVE STYLES --- */\n@media (max-width: 992px) {\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n  .page-controls {\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 768px) {\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-header h3,\n  .page--empty h3 {\n    font-size: 16px;\n  }\n  .data-table td {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
